module.exports = __webpack_public_path__ + "static/media/white-music-icon.c500cd7e.svg";